import { User } from "@/models";
import { getApiClient, IApiClient } from "./ApiClient/ApiClient";
import IResponseModel from "./ResponseModel";
import logger, { LoggingSource } from "@/shared/Logger";

export default class UserApi {
  private readonly _apiClient: IApiClient;
  constructor(apiClient: IApiClient = getApiClient()) {
    this._apiClient = apiClient;
  }

  async getAccountList(userReference: string): Promise<IResponseModel<User>> {
    try {
      logger.info("GetAccountBalanceList...", LoggingSource.UIUser);
      logger.timeStart("GetAccountBalanceList call", LoggingSource.UIUser);

      const result = await this._apiClient.get<User>(`/user/${userReference}`);

      logger.timeEnd("GetAccountBalanceList call", LoggingSource.UIUser);
      logger.debug(
        `GetAccount response: ${JSON.stringify(result)}`,
        LoggingSource.UIUser
      );

      return result;
    } catch (error) {
      logger.timeEnd("GetAccountBalanceList call", LoggingSource.UIUser);
      logger.error(JSON.stringify(error), LoggingSource.UIUser);
      throw error;
    } finally {
      logger.info("...GetAccountBalanceList", LoggingSource.UIUser);
    }
  }
}
